export default __webpack_public_path__ + "locales/pt-BR/PrivacyPage.json?hash=6b3aeeab74de5a6be9e47156c7ae81cb";